import { groupRequest } from '../../request/index';

export default {
  namespaced: true,
  state: {
    accountInfo: {}, // 主账号信息
    overViewInfo: {}, // 概览信息
    subAccountInfo: {}, // 当前查看的分账号信息
    billDictionary: [], // 计费项字典
    customInfo: {}, // ODM配置信息
  },
  actions: {
    /**
     * 主账号登录
     * yapi: http://yapi.igeeker.org/project/321/interface/api/25108
     * @param {Object} params
     * @param {String} params.email 邮箱
     * @param {String} params.phone 手机号
     */
    async login(ctx, params) {
      const res = await groupRequest.post('/login', params);
      ctx.commit('setAccountInfo', res);
      return res;
    },

    /**
     * 更新主账号信息
     * yapi: http://yapi.igeeker.org/project/321/interface/api/27466
     * @param {Object} params 参数详见接口
     */
    async updateAccountInfo(ctx, params) {
      return await groupRequest.post('/group/account/update', params);
    },
    /**
     * 添加分账号
     * yapi: http://yapi.igeeker.org/project/321/interface/api/26467
     * @param {Object} params 参数详见接口
     */
    async addSubAccount(ctx, params) {
      return await groupRequest.post('/group/user/create', params);
    },
    /**
     * 获取分账号详情
     * yapi: http://yapi.igeeker.org/project/321/interface/api/30634
     * @param {String} unionId 分账号id
     * @returns
     */
    async getSubAccountInfo(ctx, unionId) {
      return await groupRequest.get('/group/user/get', {
        params: {
          unionId,
        },
      });
    },

    /**
     * 获取集团账号资源列表
     * yapi: http://yapi.igeeker.org/project/321/interface/api/35361
     */
    async getGroupResource() {
      return await groupRequest.get('/group/resource/account/get');
    },

    /**
     * 获取资源充值改动记录
     * yapi: http://yapi.igeeker.org/project/321/interface/api/35363
     * @param {Object} params
     * @param {String} params.pageNumber  当前页数
     * @param {String} params.pageSize 分页数量
     * @param {String} params.resourceCodes 资源id
     * @returns
     */
    async getGroupResourceRecord(ctx, params = {}) {
      return await groupRequest.get('/group/resource/log/page', {
        params: { ...params },
      });
    },

    /**
     * 导出资源充值改动记录
     * https://yapi.igeeker.org/project/321/interface/api/49263
     * @param {Object} params 参数详见接口
     */
    async exportGroupResourceRecord(ctx, params = {}) {
      return await groupRequest.get('/group/resource/log/export', { params });
    },

    /**
     * 设置分账号状态
     * yapi: http://yapi.igeeker.org/project/321/interface/api/26503
     * @param {Object} params
     * @param {String} params.status 状态,FROZEN-冻结 NORMAL-正常（解冻）
     * @param {String} params.unionId 分账号id
     */
    async changeSubAccountStatus(ctx, params) {
      return await groupRequest.post('/group/user/status/update', params);
    },
    /**
     * 获取计费项枚举
     * yapi:  http://yapi.igeeker.org/project/321/interface/api/27592
     */
    async getBillDictionary() {
      return await groupRequest.get('/common/billing-daily-enum/get');
    },

    /**
     * 获取分账号列表
     * yapi: http://yapi.igeeker.org/project/321/interface/api/26476
     * @param {Object} params
     * @param {String} params.pageNumber  当前页数
     * @param {String} params.pageSize 分页数量
     * @param {String} params.memo 分账号备注
     */
    async getSubAccountList(ctx, params) {
      const {
        pageNumber,
        pageSize,
        email,
        memo
      } = params;
      return await groupRequest.get('/group/user/list', {
        params: {
          pageNumber,
          pageSize,
          email,
          memo
        },
      });
    },
    /**
     * 更新分账号信息
     * yapi: http://yapi.igeeker.org/project/321/interface/api/26683
     */
    async updateSubAccountInfo(ctx, params) {
      return await groupRequest.post('/group/user/update', params);
    },
    /**
     * 获取概览详情
     * yapi: http://yapi.igeeker.org/project/321/interface/api/26512
     */
    async getOverViewInfo(ctx) {
      const res = await groupRequest.get('/group/account/get');
      ctx.commit('setOverView', res);
      ctx.commit('setAccountInfo', res);
      return res;
    },

    /**
     * 获取主账号阈值
     * yapi: http://yapi.igeeker.org/project/321/interface/api/26575
     */
    async getThreshold() {
      return await groupRequest.get('/group/account/threshold/get');
    },

    /**
     * 设置主账号阈值
     * yapi: http://yapi.igeeker.org/project/321/interface/api/26584
     * @param {Object} params 参数详见接口
     */
    async saveThreshold(ctx, params) {
      return await groupRequest.post('/group/account/threshold/save', params);
    },
    /**
     * 获取分账号云直播设置
     * yapi: https://yapi.igeeker.org/project/321/interface/api/26719
     * @param {Number} unionId 分账号id
     */
    async getLivePackage(ctx, unionId) {
      return await groupRequest.get('/group/user/live-package/get', {
        params: {
          unionId,
        },
      });
    },
    /**
     * 更新分账号云直播设置
     * yapi: https://yapi.igeeker.org/project/321/interface/api/26728
     * @param {Object} params 参数详见接口
     */
    async updateLivePackage(ctx, params) {
      return await groupRequest.post('/group/user/live-package/update', params);
    },
    /**
     * 更新分账号点播设置
     * yap: https://yapi.igeeker.org/project/321/interface/api/26737
     * @param {Object} params 参数详见接口
     */
    async updateVodPackage(ctx, params) {
      return await groupRequest.post('/group/user/vod-package/update', params);
    },
    /**
     * 获取主账号账单统计
     * yapi: http://yapi.igeeker.org/project/321/interface/api/27628
     * @param {Object} params 参数详见接口
     */
    async getAccountBill(ctx, params) {
      return await groupRequest.get('/group/account/billing-daily/list', {
        params,
      });
    },
    /**
     * 获取账号用量
     * yap: http://yapi.igeeker.org/project/321/interface/api/27574
     * @param {Object} params 参数详见接口
     */
    async getAccountDosage(ctx, params) {
      return await groupRequest.get('/group/user/billing-daily/list', {
        params,
      });
    },
    /**
     * 获取开发设置
     * yap: http://yapi.igeeker.org/project/321/interface/api/27574
     */
    async getDevelopInfo() {
      return await groupRequest.get('/group/account/callback/get');
    },

    /**
     * 开发设置
     * yap: http://yapi.igeeker.org/project/321/interface/api/27574
     */
    async setDevelopInfo(ctx, form) {
      return await groupRequest.post('/group/account/callback/update', form);
    },
    /**
     * 导出主账号账单
     *  yapi: http://yapi.igeeker.org/project/321/interface/api/27637
     * @param {Object} params 参数详见接口
     * @returns
     */
    async exportBillFile(ctx, params) {
      return await groupRequest.get('/group/account/billing-daily/export', { params });
    },
    /**
     * 导出账号用量
     * yapi: http://yapi.igeeker.org/project/321/interface/api/27610
     * @param {Object} params 参数详见接口
     */
    async exportDosageFile(ctx, params) {
      return await groupRequest.get('/group/user/billing-daily/export', { params });
    },
    /**
     * 获取单价设置
     * yapi: http://yapi.igeeker.org/project/321/interface/api/26953
     * @param {Number} unionId 分账号id
     */
    async getBillItems(ctx, unionId) {
      return await groupRequest.get('/group/user/billing-item/list-all', {
        params: {
          unionId,
        },
      });
    },
    /**
     * 单价设置更新
     * ypai: http://yapi.igeeker.org/project/321/interface/api/26962
     * @param {*} params 参数详见接口
     */
    async updateBillItems(ctx, params) {
      return await groupRequest.post('/group/user/billing-item/update', params);
    },

    /**
     * 直播资源分配
     * @param ctx
     * yapi: http://yapi.igeeker.org/project/321/interface/api/35487
     * @param params
     */
    async allocateLiveResource(ctx, params) {
      return await groupRequest.post('/group/resource/allocate-live', params);
    },

    /**
     * 点播资源分配
     * @param ctx
     * @param params
     */
    async allocateVodResource(ctx, params) {
      return await groupRequest.post('/group/resource/allocate-vod', params);
    },

    /**
     * 获取集团账号定制
     * yapi: http://yapi.igeeker.org/project/321/interface/api/38381
     */
    async getGroupCustom(ctx, params) {
      return await groupRequest.get('/group/custom/get', {
        params: {
          domain: params.domain
        },
      });
    },

    /**
     * 修改密码 - 发送邮件
     */
    async forgetPassword(ctx, params) {
      return await groupRequest.post('/forget', params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
    },

    /**
     * 修改密码
     */
    async resetPassword(ctx, params) {
      return await groupRequest.post('/reset-password', params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
    },

    /**
     * 获取直播场次统计数据
     * http://yapi.igeeker.org/project/321/interface/api/4103
     * @param {Object} params
     * @param {String} params.pageNumber  当前页数
     * @param {String} params.pageSize 分页数量
     * @param {String} params.startTime  账单开始时间
     * @param {String} params.endTime 账单结束时间
     * @param {String} params.unionId 分账号id
     * @param {String} params.email 分账号邮箱
     * @param {String} params.channelId 频道号
     */
    async getStatisticsSummary(ctx, { channelId, email, endDate, startDate, pageNumber = 1, pageSize = 10 } = {}) {
      return await groupRequest.get('/group/account/session/statistic/list', {
        params: {
          pageSize,
          pageNumber,
          channelId,
          email,
          startTime: startDate,
          endTime: endDate
        },
      });
    },
    /**
     * 导出直播场次统计数据
     * http://yapi.igeeker.org/project/321/interface/api/4100
     * @param {Object} params
     * @param {String} params.startTime  账单开始时间
     * @param {String} params.endTime 账单结束时间
     * @param {String} params.unionId 分账号id
     * @param {String} params.email 分账号邮箱
     * @param {String} params.channelId 频道号
     */
    async exportstaticsDetail(ctx, { channelId, email, endDate, startDate, unionId } = {}) {
      return await groupRequest.get('/group/account/session/statistic/export', {
        params: {
          channelId,
          email,
          unionId,
          startTime: startDate,
          endTime: endDate
        }
      });
    }
  },
  mutations: {
    setAccountInfo(state, accountInfo) {
      state.accountInfo = accountInfo;
    },
    setOverView(state, overViewInfo) {
      state.overViewInfo = overViewInfo;
    },
    setSubAccountInfo(state, subAccountInfo) {
      state.subAccountInfo = subAccountInfo;
    },
    setBillDictionary(state, billDictionary) {
      state.billDictionary = billDictionary;
    },
    updatePackageChannels(state, packageChannels) {
      state.overViewInfo.usedChannels = packageChannels;
    },
    updatePackageConcurrent(state, packageConcurrent) {
      state.overViewInfo.usedConcurrent = packageConcurrent;
    },
    setCustomInfo(state, customInfo) {
      state.customInfo = customInfo;
    },

  },
  getters: {
    accountInfo: (state) => state.accountInfo,
    overViewInfo: (state) => state.overViewInfo,
    subAccountInfo: (state) => state.subAccountInfo,
    customInfo: (state) => state.customInfo,
  },
};
